/**
 * Perfis de usuário (D-013). Espelham o enum `perfil_usuario_enum` do banco —
 * um teste da API confere que as duas listas são iguais.
 */
export const PERFIS = [
  'superadmin',
  'admin',
  'gestor',
  'gestor_regional',
  'medico',
  'enfermeiro',
  'recepcao',
  'visualizador',
] as const;

export type Perfil = (typeof PERFIS)[number];

export interface DescricaoPerfil {
  rotulo: string;
  descricao: string;
  /** Pode ver dados clínicos identificados de pacientes? */
  vePacienteIdentificado: boolean;
}

export const DESCRICAO_PERFIS: Record<Perfil, DescricaoPerfil> = {
  superadmin: {
    rotulo: 'Superadministrador',
    descricao: 'Gestão global, protocolos e registro de acessos. Sem acesso a conteúdo clínico.',
    vePacienteIdentificado: false,
  },
  admin: {
    rotulo: 'Administrador do município',
    descricao: 'Usuários e unidades de saúde do município.',
    vePacienteIdentificado: false,
  },
  gestor: {
    rotulo: 'Gestor municipal',
    descricao: 'Indicadores, pendências e notificações do município.',
    vePacienteIdentificado: true,
  },
  gestor_regional: {
    rotulo: 'Gestor regional',
    descricao: 'Indicadores agregados de vários municípios, sem identificação de pacientes.',
    vePacienteIdentificado: false,
  },
  medico: {
    rotulo: 'Médico(a)',
    descricao: 'Linha de cuidado completa, incluindo a conduta do fluxograma neonatal.',
    vePacienteIdentificado: true,
  },
  enfermeiro: {
    rotulo: 'Enfermeiro(a)',
    descricao: 'Linha de cuidado e aplicação de doses.',
    vePacienteIdentificado: true,
  },
  recepcao: {
    rotulo: 'Recepção',
    descricao: 'Cadastro, busca e agenda. Sem dados clínicos.',
    vePacienteIdentificado: false,
  },
  visualizador: {
    rotulo: 'Visualizador',
    descricao: 'Indicadores agregados, somente leitura.',
    vePacienteIdentificado: false,
  },
};
